import { Modal } from "antd";
import EditPatientInfo, { PatientFormType } from "./EditPatientInfo";
import { emptyPatient, Patient, StrongHandType } from "./interfaces";
import "./EditPatientInfo.css";

const defaultPatient: Patient = {
  ...emptyPatient,
  strongHand: StrongHandType.DX,
};

const AddPatientModal = ({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: Function;
}) => {
  return (
    <Modal
      className="modal-addpat"
      title="Aggiungi un nuovo paziente"
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={1000}
    >
      <EditPatientInfo
        basePatient={defaultPatient}
        formType={PatientFormType.ADD}
      />
    </Modal>
  );
};

export default AddPatientModal;
